import { render, staticRenderFns } from "./EditCodingTest.vue?vue&type=template&id=1cf0be92"
import script from "./EditCodingTest.vue?vue&type=script&lang=js"
export * from "./EditCodingTest.vue?vue&type=script&lang=js"
import style0 from "./EditCodingTest.vue?vue&type=style&index=0&id=1cf0be92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports